import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, IconButton, Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';  // Eye icon for viewing
import { useNavigate } from 'react-router-dom'; // Import useNavigate for navigation

const ManageCars = () => {
  const [cars, setCars] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [confirmDelete, setConfirmDelete] = useState(false); // For delete confirmation
  const [carToDelete, setCarToDelete] = useState(null); // Store the car ID to delete

  // Initialize useNavigate hook
  const navigate = useNavigate();

  // Fetch data from API using axios
  useEffect(() => {
    axios.post('https://genzserver.mylksystems.com/Cars/getAllCarDetails')
      .then((response) => {
        setCars(response.data.data); // Assuming the response has a 'data' property with the array of cars
      })
      .catch((error) => {
        console.error("There was an error fetching the cars data!", error);
      });
  }, []);

  // Filter cars based on search query
  const filteredCars = cars.filter((car) =>
    car.CarCategory.toLowerCase().includes(searchQuery.toLowerCase()) ||
    car.Remark.toLowerCase().includes(searchQuery.toLowerCase())
  );

  // Handle image click to open modal
  const handleClickOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  // Handle modal close
  const handleClose = () => {
    setOpen(false);
    setSelectedImage('');
  };

  // Handle row click to navigate to UpdateCar
  const handleUpdateClick = (carId) => {
    navigate('/UpdateCars', { state: { carId: carId } }); // Pass carId via state
  };

  // Open the delete confirmation dialog
  const handleDeleteClick = (carId) => {
    setCarToDelete(carId); // Store the car ID to delete
    setConfirmDelete(true); // Open the confirmation dialog
  };

  // Close the delete confirmation dialog
  const handleCloseDelete = () => {
    setConfirmDelete(false);
    setCarToDelete(null);
  };

  // Handle deleting the car
  const handleConfirmDelete = () => {
    if (carToDelete) {
      // Make an API call to delete the car
      axios.post('https://genzserver.mylksystems.com/Cars/deleteCar', { carId: carToDelete })
        .then((response) => {
          console.log(response.data);
          setCars(cars.filter((car) => car.carid !== carToDelete)); // Remove the deleted car from the list
          handleCloseDelete();
        })
        .catch((error) => {
          console.error("Error deleting car:", error);
          alert('Failed to delete the car. Please try again.');
        });
    }
  };

  return (
    <div style={{ margin: '20px' }}>
      <div style={{ marginBottom: '20px', fontSize: '24px', fontWeight: 'bold' }}>
        Car Rental Management
      </div>

      {/* Search Bar */}
      <TextField
        label="Search Cars"
        variant="outlined"
        onChange={(e) => setSearchQuery(e.target.value)}
        style={{ marginBottom: '20px', width: '300px', float: 'right' }}
      />

      {/* Material UI Table */}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ fontWeight: 'bold' }}>Car ID</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Category</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Passenger Count</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Remark</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Rate</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Image</TableCell>
              <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredCars.map((car) => (
              <TableRow
                key={car.carid}
                style={{ textDecoration: 'none', cursor: 'pointer' }}
              >
                <TableCell>{car.carid}</TableCell>
                <TableCell>{car.CarCategory}</TableCell>
                <TableCell>{car.PassengetCount}</TableCell>
                <TableCell>{car.Remark}</TableCell>
                <TableCell>{car.rate}</TableCell>
                <TableCell>
                  <IconButton onClick={() => handleClickOpen(`https://genzserver.mylksystems.com/Assets/Cars/${car.image}`)}>
                    <VisibilityIcon />
                  </IconButton>
                </TableCell>
                <TableCell>
                  {/* Update Button */}
                  {/* <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleUpdateClick(car.carid)}
                    style={{ marginRight: '10px' }}
                  >
                    Update
                  </Button> */}
                  {/* Delete Button */}
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => handleDeleteClick(car.carid)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog for viewing the image */}
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Car Image</DialogTitle>
        <DialogContent>
          <img
            src={selectedImage}
            alt="Car"
            style={{ width: '100%', height: 'auto' }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} style={{ margin: '0 10px', padding: '5px 15px' }}>Close</Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={confirmDelete} onClose={handleCloseDelete}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <p>Are you sure you want to delete this car?</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ManageCars;
